import React, { Component } from "react";
import api from "../api";
import { Alert, InputGroup, FormControl, Button, Form } from "react-bootstrap";
// import * as jwt_Decode from "jwt-decode";
import jwt_decode from "jwt-decode";
import jstz from "jstz";

export default class Login extends Component {
  state = {
    liErrorShow: false
  };

  tz = () => {
    let timezone = jstz.determine();
    let val = timezone.name();
    return val;
  };

  decoder = token => {
    // console.log("Decoder run");
    // this.props.jwt ? console.log("jwt exist") : console.log("jwt don't exist");

    if (token) {
      let decoded = jwt_decode(token);
      // console.log(decoded);
      // this.setState({ decoded: decoded });
      return decoded;
    }
  };

  inputChangeHandler = event => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  };

  submitLogin = () => {
    fetch(api.server + "/users/login", {
      method: "post",
      headers: { "Content-type": "application/json" },
      body: JSON.stringify({
        userData: {
          userName: this.state.userName,
          password: this.state.password,
          timeZone: this.tz()
        }
      })
    })
      .then(response => response.json())
      .then(res => {
        console.log("res.message: ", res.message);

        if (res.message === "Auth Faild") {
          this.setState({ liErrorShow: true });
        }
        if (res.message === "Auth sucess") {
          this.setState({ liErrorShow: false });
          this.props.updateJWT({
            jwt: res.token,
            decoded: this.decoder(res.token)
          });
          this.props.history.push("/");
        }
        else{
          this.setState({ liErrorShow: true });
        }
      })
      .catch(error => console.log("something failed", error));

    // console.log("submitLogin");
    // console.log(this.state.userName);
    // console.log(this.state.password);

    // auth.login(
    //   () => {
    //     console.log("auth.login");
    //     this.props.history.push("/");
    //   },
    //   this.state.userName,
    //   this.state.password
    // );
  };

  render() {
    return (
      <React.Fragment>
        <Alert variant={"primary"}>Login</Alert>
        {this.state.liErrorShow && (
          <Alert variant={"danger"}>User Name / Password Wrong!!!</Alert>
        )}
        <Form>
          <InputGroup className="mb-3">
            <InputGroup.Prepend>
              <InputGroup.Text id="basic-addon1">User Name</InputGroup.Text>
            </InputGroup.Prepend>
            <FormControl
              type="text"
              name="userName"
              placeholder="User name / Email"
              aria-label="userName"
              aria-describedby="basic-addon1"
              onChange={this.inputChangeHandler}
              onKeyDown={event => {
                if (event.key === "Enter") {
                  this.submitLogin();
                }
              }}
            />
          </InputGroup>
          <InputGroup className="mb-3">
            <InputGroup.Prepend>
              <InputGroup.Text id="basic-addon1">Password</InputGroup.Text>
            </InputGroup.Prepend>
            <FormControl
              type="password"
              name="password"
              placeholder="********"
              aria-label="password"
              aria-describedby="basic-addon1"
              autoComplete="off"
              onChange={this.inputChangeHandler}
              onKeyDown={event => {
                if (event.key === "Enter") {
                  this.submitLogin();
                }
              }}
            />
          </InputGroup>
          <Button variant="outline-primary" onClick={this.submitLogin}>
            LOGIN
          </Button>
        </Form>
      </React.Fragment>
    );
  }
}
